<template>
    <div class=" col-sm-12 col-md-10 col-lg-7">
        <b-card class="country-chooser-card">
            <b-card-text class="d-flex h-100">
                <div class="w-100">
                    <div class="w-100">
                        <div class="text-center p-2 globe-container">
                            <img src="../assets/imgs/fa-solid-globe-europe.svg" width="48px" height="48px" />
                        </div>
                        <p class="text-center p-1">
                            {{ $t("countryChooser.chooseAnotherCounrtry") }}
                        </p>
                    </div>
                    <b-list-group class="country-chooser">
                        <transition-group name="flip-list">
                            <country-item v-for="country in countryOrder"
                                          :key="country"
                                          :title="$t(`countryChooser.${country}`)"
                                          :href="countries[country].link"
                                          :flag-svg="countries[country].flag"
                                          :logo="countries[country].logo"/>
                        </transition-group>
                    </b-list-group>
                </div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>

    import CountryItem from "./CountryItem";
    export default {
        name: "ChooserWithIcon",
        components: {CountryItem},
        props: {
            lang: {
                type: String,
                default: 'hu'
            }
        },
        data() {
            return {
                countries: {
                    hu: {
                        link: 'https://www.bardiauto.hu',
                        flag: require('../assets/imgs/hungary.svg'),
                        logo: require('../assets/imgs/ba_hu.svg')
                    },
                    ro: {
                        link: 'https://www.bardiauto.ro',
                        flag: require('../assets/imgs/romania.svg'),
                        logo: require('../assets/imgs/ba_ro.svg')
                    },
                    sk: {
                        link: 'https://www.bardiauto.sk',
                        flag: require('../assets/imgs/slovakia.svg'),
                        logo: require('../assets/imgs/ba_sk.svg')
                    },
                }
            };
        },
        computed: {
            countryOrder() {

                let retval = [];

                switch (this.lang) {
                    case 'ro':
                        retval = ['ro', 'hu', 'sk'];
                        break;
                    case 'sk':
                        retval = ['sk', 'hu', 'ro'];
                        break;
                    default:
                        retval = ['hu', 'ro', 'sk'];
                }
                return retval;
            }
        },
    }
</script>
<style lang="scss">
    $chRadius: 6px;
    $chSize: 22px;
    $chBlue: #EE3124;
    $chRed: #2B6BB2;
    $chDiff: -11px;
    $chBorderWeight: 4px;

    .country-title {
        padding-left: 1.25rem;
    }
    .country-chooser-card {
        &::before {
            display: block;
            content: "";
            width: $chSize;
            height: $chSize;
            position: absolute;
            bottom: $chDiff;
            left: $chDiff;
            border-bottom: $chBorderWeight solid $chBlue;
            border-left: $chBorderWeight solid $chBlue;
            -webkit-border-bottom-left-radius: $chRadius;
            -moz-border-radius-bottomleft: $chRadius;
            border-bottom-left-radius: $chRadius;
        }
        &::after {
            display: block;
            content: "";
            width: $chSize;
            height: $chSize;
            position: absolute;
            top: $chDiff;
            right: $chDiff;
            border-top: $chBorderWeight solid $chRed;
            border-right: $chBorderWeight solid $chRed;
            -webkit-border-top-right-radius: $chRadius;
            -moz-border-radius-topright: $chRadius;
            border-top-right-radius: $chRadius;
        }
        .globe-container {
            margin-top: -0.5rem;
        }
    }

    .flip-list-move {
        transition: transform 1s;
    }
</style>

